<template>
  <section class="auth-form">
    <form class="form" @submit.prevent="login">
      <h1 class="form__title">{{$t('loginForm.enter')}}</h1>
      <p class="form__description">
        {{$t('loginForm.description')}}
      </p>
      <div class="form__fields">
      <input-app
          :placeholder="$t('loginForm.placeholderPhone')"
          name="phone"
          v-model="$v.phone.$model"
          :label-text="$t('loginForm.labelPhoneNumber')"
          type="tel"
          @blur="$v.phone.$touch()"
          :error="submitted && $v.phone.$error"
      />
      <div v-if="submitted && $v.phone.$error" class="invalid-message">
        <span v-if="!$v.phone.required">{{$t('validateText.required')}}</span>
        <span v-if="!$v.phone.minLength">
         {{$t('validateText.incorrectPhone')}}
        </span>
      </div>
      <div class="form__wrap-password-input">
        <router-link class="forget-password" :to="'restore_password'">
         {{$t('loginForm.forgotPassword')}}
        </router-link>
        <input-app
            :placeholder="$t('loginForm.placeholderPassword')"
            name="password"
            v-model="password"
            :label-text="$t('loginForm.labelPassword')"
            type="password"
            :error="submitted && $v.password.$error"
            :use-lang-hint="true"
        />
      </div>
      <div v-if="submitted && $v.password.$error" class="invalid-message">
        <span v-if="!$v.password.required">{{$t('validateText.required')}}</span>
        <span v-if="!$v.password.minLength">{{$t('validateText.shortPassword')}}</span>
      </div>
      <b-form-checkbox
          id="checkbox-2"
          name="checkbox-2"
          class="form__checkbox"
          button-variant="outline-secondary"
          v-model="remember"
      >
        {{$t('loginForm.keepMeSignedIn')}}
      </b-form-checkbox>
      </div>
      <button-app
        type="submit"
        :disabled="password.length === 0 || phone.length === 0"
      >
        <AppLoader v-if="authStatus === 'loading' || isFormSubmitting" />
        <span v-else>{{$t('loginForm.buttonNext')}}</span>
      </button-app>
      <transition name="form__error__fade">
        <p v-if="error" class="form__error">
          {{$t('validateText.errorLoginSubmit')}}
        </p>
      </transition>
    </form>
    <div class="account-info-answer">
      <span class="answer">{{$t('loginForm.haveAccount')}}</span>
      <router-link class="sign-up-link" :to="'signup'">
        {{$t('loginForm.registrationLink')}}
      </router-link>
    </div>
  </section>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators';
import { mapState } from 'vuex';
import { AUTH_LOGOUT, AUTH_REQUEST } from '@/store/auth/types';
import {
  FETCH_EVENT_REQUEST,
  FETCH_EVENTS_REQUEST,
  FETCH_OPERATIONS_REQUEST,
} from '@/store/events/types';
import InputApp from '../../components/Input/InputApp';
import ButtonApp from '../../components/Button/ButtonApp';
import AppLoader from '../../components/AppLoader/AppLoader';

export default {
  name: 'LoginForm',
  validations: {
    phone: {
      required,
      minLength: minLength(11),
    },
    password: {
      required,
      minLength: minLength(5),
    },
  },
  components: {
    ButtonApp,
    InputApp,
    AppLoader,
  },
  component: {
    InputApp,
  },
  data() {
    return {
      phone: '',
      password: '',
      submitted: false,
      remember: true,
      isFormSubmitting: false,
    };
  },
  methods: {
    async login() {
      this.isFormSubmitting = true;
      try {
        const { phone, password, remember } = this;
        this.submitted = true;
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.isFormSubmitting = false;
          return;
        }
        await this.$store.dispatch(AUTH_REQUEST, {
          phone,
          password,
          remember,
        });
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('unable to login: ', e.message);
        await this.$store.dispatch(AUTH_LOGOUT);
        return;
      } finally {
        this.isFormSubmitting = false;
      }
      try {
        this.$store.commit(FETCH_EVENTS_REQUEST);
        this.$store.commit(FETCH_EVENT_REQUEST);
        this.$store.commit(FETCH_OPERATIONS_REQUEST);
        await this.$router.push('/events');
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('user has no name: going to the user initialisation page', e.message);
        await this.$router.push('/');
      }
      this.isFormSubmitting = false;
    },
  },
  computed: {
    ...mapState({
      error: (state) => state.auth.error,
      authStatus: (state) => state.auth.authStatus,
    }),
  },
};
</script>
